import { Box, Switch, IconButton } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import AptaTable from 'examples/AptaTable';
import MDTypography from 'components/MDTypography';
import axios from 'axios';
import { URL } from 'constants/constant';
import Swal from 'sweetalert2';
import { SearchInput } from 'layouts/speakers';

const ContactUsReport = () => {
    const [contacts, setContacts] = useState([]);
    const [search, setSearch] = useState('');
    const [filteredContacts, setFilteredContacts] = useState([]);

    const getContacts = async () => {
        try {
            const response = await axios.get(`${URL}/api/admin/contactus`);
            if (response.data) {
                setContacts(response.data.data || response.data); // handle both array and {data:[]} response
            }
        } catch (err) {
            console.error("Error fetching contacts:", err);
            Swal.fire("Error!", "Failed to fetch contact us data.", "error");
        }
    };

    const handleSoftDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will mark as completed",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`${URL}/api/admin/contactus/${id}`);
                    Swal.fire("Success!", "The contact has been marked as completed.", "success");
                    getContacts();
                } catch (err) {
                    console.error("Delete error:", err);
                    Swal.fire("Error!", "Failed to mark contact as completed.", "error");
                }
            }
        });
    };

    useEffect(() => {
        getContacts();
    }, []);

    useEffect(() => {
        if (!search) {
            setFilteredContacts(contacts);
        } else {
            setFilteredContacts(
                contacts.filter(
                    (item) =>
                        item.name?.toLowerCase().includes(search.toLowerCase()) ||
                        item.email?.toLowerCase().includes(search.toLowerCase()) ||
                        String(item.number).toLowerCase().includes(search.toLowerCase()) ||
                        item.message?.toLowerCase().includes(search.toLowerCase())
                )
            );
        }
    }, [search, contacts]);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SearchInput searchQuery={search} handleSearchChange={(e) => setSearch(e.target.value)} />
            <AptaTable
                columns={['Name', 'Email', 'Number', 'Message', 'Mark']}
                rows={filteredContacts?.map((item) => ({
                    Name: <MDTypography variant="caption">{item?.name}</MDTypography>,
                    Email: <MDTypography variant="caption">{item?.email}</MDTypography>,
                    Number: <MDTypography variant="caption">{item?.number}</MDTypography>,
                    Message: <MDTypography variant="caption">{item?.message}</MDTypography>,
                    Mark: (
                        <Switch
                            color="error"
                            onChange={() => handleSoftDelete(item?._id)}
                        />
                    ),
                }))}
            />
        </DashboardLayout>
    );
};

export default ContactUsReport;